<template>
    <a class="dropdown-item" :href="href" :class="[checkActive() ? 'active' : '']">
        <slot/>
    </a>
</template>
<script>
export default {
    name: 'DefaultLinkDropDownMenuItem',
    props: {
        href: {
            type: String,
            required: true
        }
    },
    methods: {
        checkActive() {
            return (window.location.origin + this.$route.path).includes(this.href);
        }
    }
}
</script>
